import React, { useEffect, useState } from 'react'
import withRouter from '../../withRouter'
import { createTheme, FormControlLabel, ThemeProvider } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import IOSSwitch from '../../CommonComponents/IOSSwitch';
import MUIDataTable from 'mui-datatables';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import { Link, useNavigate } from 'react-router-dom';
import { spin } from '../../Common/NewLoader';
import Footer from '../../Component/Footer';
import CustomToolbar from '../../CommonComponents/CustomToolbar';
import SalesServices from '../../Sales/SalesServices';
import { address, address2, ccity, ccountry, clientname, companyemail, contactnumber, cstate, currentTenant, czip, gstin, logo, pan, thousandsdisplay } from '../../Common/Credentials';
import moment from 'moment';
import DirectDNCNServices from './DirectDNCNServices';
import Swal from 'sweetalert2';
import { ToWords } from 'to-words';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import CustomerService from '../../Masters/Customers/CustomerService';
import SupplierService from '../../Masters/Suppliers/SupplierService';
import AgentServices from '../../Masters/Agents/AgentServices';

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
          border: [[1, 'solid', '#ece6e6']], 
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});

const DirectCNDN = () => {
  const navigate = useNavigate()
  const [loading,setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("Pending")
  const [data,setData] = useState([])
  const [pendingData,setPendingData] = useState([])
  const [cancelledData,setCancelledData] = useState([])
  const [completedData,setCompletedData] = useState([])
  const [imgwidth, setImgwidth] = useState(0);
  const [imgheight, setImgheight] = useState(0);
  

  const GetAllDirectCNDN = () =>{
    DirectDNCNServices.getallcndn(currentTenant).then(res=>{
      setData(res.data)
        setPendingData(res.data.filter(e=>e.status !== "Cancelled" && e.accstatus ==="Pending" ))
        setCompletedData(res.data.filter(e=>e.status !== "Cancelled" && e.accstatus ==="Completed" ))
        setCancelledData(res.data.filter(e=>e.status === "Cancelled"))
    })
  }

  useEffect(()=>{
    let i = new Image();
    i.src = logo;
    setTimeout(() => {
      setImgwidth(i.naturalWidth);
      setImgheight(i.naturalHeight);
    }, 100);
  },[])
  useEffect(()=>{
    GetAllDirectCNDN()
  },[])

  const handleChangeTab = (val) =>{
    setActiveTab(val)
  }

  const handleUpdateStatus = (id,status) =>{
    DirectDNCNServices.approvedirectcndn(id,status).then(()=>{
    GetAllDirectCNDN()
  })
  }

  const handleAction = (id,type) =>{
    let pendingso  =  data.filter(e=>e.customid === id)
    // navigate("/cnentry",selected)
    if(type==="Receivable"){
    navigate("/dcnentry", { state: {pendingso} })
    }else{
      navigate("/ddnentry", { state: {pendingso} })
    }



   // {
  //  console.log(id,type),
    //<Link as="button" className="float-right btn btn-sm m-0 p-0" 
      // to={{pathname: "/cnentry"}} state ={{selected}}>
 //</Link>
 // }
     {/* this.props.navigate({pathname:`/cnentry`}, {state:pendingso}); */}
    
  
    //
  }

  const columns = [
    {name: "customid",label: "id",options: {filter: true,sort: true,viewColumns:true}},
    {name: "type",label: "Type",options: {filter: true,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "against",label: "Against",options: {filter: true,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "companyname",label: "Company Name",options: {filter: true,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "amount",label: "Amount",options: {filter: false,sort: true,sortOrder: 'asc',
      customBodyRender:(tableMeta)=>{
        return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay
        }></NumericFormat>)
      },
      setCellProps: value => ({ style: { textAlign:'right'}}),
    }},
  {name: "createdAt",label: "Date",options: {filter: false,sort: true, 
    customBodyRender:(tableMeta)=>{
      return(moment(tableMeta).format('DD-MM-YYYY HH:mm:ss'))
    }}},
    {name: "status",label: "Status",options: {filter: false,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "accstatus",label: "Account Status",options: {filter: false,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "description",label: "Description",options: {filter: false,sort: true,setCellProps: () => ({ align: 'center' })}},
    {name: "status",label: "Action",options: {filter: false,sort: true,sortOrder: 'asc',
      customBodyRender:(rowData,tableMeta)=>{
        return<div className='d-flex gap-2'>{tableMeta.rowData[7]==="Completed"?"":rowData ==="Pending"?<><button className='btn btn-sm hovbuttonColour' onClick={()=>handleUpdateStatus(tableMeta.rowData.find(e=>e),"Approved")}>Approve</button><button className='btn btn-sm deletebutton ml-1' onClick={()=>handleUpdateStatus(tableMeta.rowData.find(e=>e),"Cancelled")}>Cancel</button></>: 
        rowData ==="Approved"?tableMeta.rowData[1] === "Credit" && tableMeta.rowData[2] === "Customer"?<button className='btn btn-sm hovbuttonColour' onClick={()=>handleAction(tableMeta.rowData.find(e=>e),"Payable")}>{"Payable"}</button>
        :tableMeta.rowData[1] === "Debit" && tableMeta.rowData[2] === "Customer"?<button className='btn btn-sm hovbuttonColour' onClick={()=>handleAction(tableMeta.rowData.find(e=>e),"Receivable")}>{"Receivable"}</button>
        :tableMeta.rowData[1] === "Credit" && tableMeta.rowData[2] !== "Customer"?<button className='btn btn-sm hovbuttonColour' onClick={()=>handleAction(tableMeta.rowData.find(e=>e),"Receivable")}>{"Receivable"}</button>
        :tableMeta.rowData[1] === "Debit" && tableMeta.rowData[2] !== "Customer"?<button className='btn btn-sm hovbuttonColour' onClick={()=>handleAction(tableMeta.rowData.find(e=>e),"Payable")}>{"Payable"}</button>:""
        :rowData}
        <button className='btn btn-sm hovbuttonColour ml-1' onClick={()=>handleDownload(data.find(e=>e.customid === tableMeta.rowData.find(e=>e)),"Payable")}> <i className="fa fa-file-invoice-dollar"></i></button>
        </div>
      },
      setCellProps: value => ({ style: { textAlign:'right'}}),
    }},
   ];

   const options = {
    filterType: 'checkbox',
    selectableRows: "none",
    customToolbar: () => {
     return (<>
         <Link as="button" className="float-right btn btn-sm m-0 p-0" to={{pathname: "/newsalesdirectcndn"}} state ={ { id: -1, pagename: "Damage" }}>
           <CustomToolbar />
         </Link>
        {/* <span as="button" onClick={this.pdf.bind(this)}>
          <React.Fragment>
     <Tooltip title={"pdf"}>
       <IconButton>
       <i className="fa fa-file-pdf"></i>
       </IconButton>
     </Tooltip>
   </React.Fragment>
   </span> */}
     </>);
   }
  }


  const handleDownload = async(creditnote,type) =>{
    if(creditnote.against === "Customer"){
   await CustomerService.retriveCustomer(creditnote.companyid).then((res)=>{
      if(res.data){
        handleDownloadpdf(creditnote,type,res.data)
      }
    })
  }else{
    let companydata
    await  SupplierService.retriveSupplier(creditnote.companyid).then((res)=>{
      if(res.data){
        companydata = res.data
      }
    })

    await AgentServices.getAgentById(creditnote.companyid).then((res)=>{
      if(res.data){
        companydata = res.data
      }
    })
    handleDownloadpdf(creditnote,type,companydata)
  }
  }

  const handleDownloadpdf = async(creditnote,type,companydata) => {
    
    let totawtax = creditnote.amount.toFixed(2);

    let date = moment(creditnote.createdAt).format("DD - MM - yyyy");
    let curdate = moment().format("DD-MM-YYYY HH:mm:ss");

    let logowidth = 0;
    logowidth = ((imgwidth - imgheight) / imgwidth) * 100;

    const toWords = new ToWords();
    var amountinwords = toWords.convert(creditnote.amount);
    // var advanceinwords = toWords.convert(advance);
    const doc = new jsPDF("p", "pt", [842, 595], true);
    let y = 0;
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#000");
    doc.setDrawColor(192, 192, 192);

    doc.setFontSize(8);

    // if (
    //   creditnote.irn !== null &&
    //   creditnote.irn !== "" &&
    //   creditnote.irn !== undefined
    // ) {
    //   doc.text("IRN", 20, 190);
    //   doc.text(`-`, 58, 190);
    //   doc.text(`${creditnote.irn}`, 65, 190);
    //   doc.text(`Ack No.`, 20, 205);
    //   doc.text(`-`, 58, 205);
    //   doc.text(`${creditnote.ackno}`, 65, 205);
    //   doc.text(`Ack Date`, 20, 220);
    //   doc.text(`-`, 58, 220);
    //   doc.text(`${creditnote.ackDt}`, 65, 220);
    //   // doc.text(`e-invoice`, 520, 190);
    //   // doc.addImage(QRcode, "GIF", 495, 190, 80, 80);
    //   doc.line(10, 240, 585, 240);
    //   y = 60;
    // }

    doc.text(`COMPANY DETAILS`, 20, y + 190);
    doc.line(10, y + 195, 585, y + 195);
    doc.text("M/S", 20, y + 205);
    doc.text(`-`, 65, y + 205);
    doc.text(`${companydata.companyname || companydata.name}`, 75, y + 205);
    doc.text(`Address`, 20, y + 215);
    doc.text(`-`, 65, y + 215);
    doc.text(`${companydata.address}`, 75, y + 215);
    doc.text(`${companydata.address2}`, 75, y + 225);
    doc.text(`${companydata.cityname}, ${companydata.statename}`, 75, y + 235);
    doc.text(`${companydata.countryname} - ${companydata.zip}`, 75, y + 245);
    doc.text(`Phone No.`, 20, y + 255);
    doc.text(`-`, 65, y + 255);
    doc.text(
      `${companydata.phonecode}-${companydata.contactnumber}`,
      75,
      y + 255
    );
    if (companydata.custgstin !== "" && companydata.custgstin !== undefined) {
      doc.text(`GSTIN`, 20, y + 265);
      doc.text(`-`, 65, y + 265);
      doc.text(`${companydata.custgstin}`, 75, y + 265);
      y = y + 10;
      doc.text(`PAN`, 20, y + 265);
      doc.text(`-`, 65, y + 265);
      doc.text(`${companydata.custgstin?.substring(2, 12)}`, 75, y + 265);
    }

    doc.setLineWidth(1.0);
    doc.line(400, y + 170, 400, y + 270);
    if (companydata.custgstin !== "" && companydata.custgstin !== undefined) {
      y = y - 10;
    }
    doc.text(`${creditnote.type} Note No`, 410, y + 205);
    doc.text(`-`, 470, y + 205);
    doc.text(`${creditnote.customid}`, 480, y + 205);
    doc.text(`Issue Date`, 410, y + 215);
    doc.text(`-`, 470, y + 215);
    doc.text(`${date}`, 480, y + 215);

    doc.setLineWidth(1.0);
    doc.line(10, y + 270, 585, y + 270);

    y = y + 270 + 10;
  
    doc.text(`Total :`, 490, y + 10,"right");
    doc.text(`${totawtax}`, 570, y + 10,"right");
     doc.text(`Total in words : ${amountinwords}`, 20, y + 10);

    doc.setLineWidth(1.0);
    doc.line(10, y + 20, 585, y + 20);
    doc.text(`Issued by, signature`, 570, y + 35, "right");

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageSize = doc.internal.pageSize;
      const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      const footer = `Page ${i} of ${pageCount}`;
      doc.line(10, 50, 585, 50);
      doc.line(10, pageHeight - 40, 585, pageHeight - 40);
      doc.line(10, 50, 10, pageHeight - 40);
      doc.line(pageWidth - 10, 50, pageWidth - 10, pageHeight - 40);
      doc.setFontSize(8);
      doc.text(`${curdate}`, 20, 60);
      doc.addImage(
        logo,
        "GIF",
        pageWidth - 100 - logowidth,
        60,
        80 + logowidth,
        80
      );
      doc.setFontSize(12);
      doc.text(`${clientname}`, 20, 75);
      doc.setFontSize(8);
      doc.text(`${address}`, 20, 85);
      doc.text(`${address2}`, 20, 95);
      doc.text(`${ccity}, ${cstate}`, 20, 105);
      doc.text(`${ccountry} - ${czip}`, 20, 115);
      doc.text(`${companyemail}`, 20, 125);
      doc.text(`${contactnumber}`, 20, 135);
      doc.text(`${pan}`, 20, 145);
      let yax = 145;
      doc.setLineWidth(1.0);
      doc.line(10, yax + 5, 585, yax + 5);
      doc.setFontSize(10);
      doc.text(`GSTIN | ${gstin}`, 20, yax + 20);
      doc.setFontSize(12);
      doc.text(`${creditnote.type} Note`, 230, yax + 20);
      doc.setFontSize(8);
      doc.setLineWidth(1.0);
      doc.line(10, yax + 30, 585, yax + 30);
      doc.setFontSize(8);
      doc.text(
        footer,
        pageWidth / 2 - doc.getTextWidth(footer) / 2,
        pageHeight - 25,
        { baseline: "bottom" }
      );
    }
      doc.autoPrint({ variant: "non-conform" });
      doc.save(`${creditnote.customid}.pdf`);
  };
  
  return (
    <div>
    <Header/>
        <Menu/>
        <div className="content-wrapper">
      <div className="card">
        <ol className="breadcrumb float-sm-right">
          <li className="breadcrumb-item text-secondary">
            <Link to="/sales">Home</Link>
          </li>
          <li className="breadcrumb-item active">Direct CN/DN</li>
        </ol>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
               

                  <div className="card-body p-0">
                    <div>{loading === true ? <div className="text-center">{spin}</div> : <>
                      <div className="row">
                    <fieldset className="form-group col-md-4">
                            <span className="mx-3">Pending</span>
                            <FormControlLabel
                              control={<IOSSwitch className="sm" checked={activeTab ==="Pending"} onChange={()=>handleChangeTab("Pending")} name="checkedB" />}
                            />
                          </fieldset>
                          <fieldset className="form-group col-md-4">
                            <span className="mx-3">Completed</span>
                            <FormControlLabel
                              control={<IOSSwitch className="sm" checked={activeTab ==="Completed"} onChange={()=>handleChangeTab("Completed")} name="checkedB" />}
                            />
                          </fieldset>
                          <fieldset className="form-group col-md-4">
                            <span className="mx-3">Cancelled</span>
                            <FormControlLabel
                              control={<IOSSwitch className="sm" checked={activeTab ==="Cancelled"} onChange={()=>handleChangeTab("Cancelled")} name="checkedB" />}
                            />
                          </fieldset>
                          </div>
                          {activeTab ==="Pending"?
                    <ThemeProvider theme={theme}> 
                    <MUIDataTable
                     className="table-sm px-3"
                      title={"Credit Notes"}
                      data={pendingData}
                      columns={columns}
                     options={options}
                    />
                    </ThemeProvider>
                    :activeTab ==="Completed"?
                    <ThemeProvider theme={theme}> 
                    <MUIDataTable
                     className="table-sm px-3"
                      title={"Credit Notes"}
                      data={completedData}
                      columns={columns}
                     options={options}
                    />
                    </ThemeProvider>:
                      <ThemeProvider theme={theme}> 
                      <MUIDataTable
                       className="table-sm px-3"
                        title={"Credit Notes"}
                        data={cancelledData}
                        columns={columns}
                       options={options}
                      />
                      </ThemeProvider>
                    }

                   </> }</div>

                    </div>
                 
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
      </div>
      <Footer/>   
    </div>
  )
}

export default withRouter(DirectCNDN)